import _ from 'lodash'
import RenderData from '../../RenderData'
import Render from './render'
import Editor from './editor'
import PropsTemplate from './propsTemplate'
import i18n from '@/i18n'

const name = 'Carousel'

const toolbarItems = [
  {
    tag: name,
    icon: 'icon-carousel',
    get label () {
      return i18n.t('microSite.carousel.name')
    },
    isShow: true
  }
]

const renders = {
  [name]: Render
}

const editors = {
  [name]: Editor
}

function getEditorTitle (renderData) {
  return i18n.t('microSite.carousel.name')
}

function createRenderData (tag, index, parent) {
  const data = {
    props: _.cloneDeep(PropsTemplate)
  }
  const renderData = new RenderData(tag, data, -1, index, parent, null)
  return renderData
}

const module = {
  name,
  toolbarItems,
  renders,
  editors,
  getEditorTitle,
  createRenderData
}

export default module
